module.exports = __webpack_public_path__ + "5be7d5275fe1a439d47c87d2bd5dd024.svg";